/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { aboutusLists } from '../../redux/aboutus_block/Aboutus';
import AboutusItem from './AboutusItem';
import './Aboutus.css';

const Aboutus = () => {
  const dispatch = useDispatch();
  const aboutus = useSelector((state) => state.Aboutus);
  const healthXchangeLink = <a href="http://hx.favyt.com/">Health Xchange</a>;
  const visionStatement = 'Envisioning a future where every individual experiences a life of dignity and independence, our vision is to be the foremost provider of compassionate and personalized homecare services in India. We aspire to set the standard for excellence, empowering individuals to thrive in the comfort and familiarity of their homes, fostering a community where well-being knows no boundaries.';
  const missionStatement = 'Committed to delivering exceptional and individualized homecare solutions, our mission is to enrich lives by promoting well-being and preserving independence within the nurturing embrace of ones home. We dedicate ourselves to providing high-quality, compassionate services that empower individuals to lead fulfilling and dignified lives through personalized care and support.';
  const wellnessApproach = 'Health Exchange distinguishes itself by adopting a holistic approach to wellness. Beyond traditional healthcare services, we emphasize preventive care, mental health support, and lifestyle management to address the overall well-being of our members.';
  const personalizedCare = 'We pride ourselves on offering personalized care navigation services. Our dedicated team ensures that each member receives tailored assistance, guiding them through healthcare options, coordinating appointments, and optimizing their health journey for a seamless and personalized experience.';
  const healthTechnologyIntegration = 'Health Exchange leverages cutting-edge health technologies to empower members with real-time health data, personalized health insights, and telehealth options. This integration not only enhances accessibility but also enables proactive health management.';
  const communityEngagement = 'What truly sets us apart is our commitment to building a supportive community. Health Exchange fosters engagement through wellness events, support groups, and educational resources, creating a network where members can share experiences and encouragement.';
  const transparentAffordableHealthcare = 'Transparency is at the core of Health Exchange. We provide clear and comprehensive information about healthcare costs, enabling members to make informed decisions. Our commitment to affordability ensures that quality healthcare remains accessible to all, promoting a healthier and more equitable community.';
  useEffect(() => {
    if (aboutus.length === 0) {
      dispatch(aboutusLists());
    }
  });

  return (
    <div>
      <div className="about-us about">
        <Container>
          <Row>
            <Col md={12}>
              <h2 className="section-heading homepage-heading">
                Health Xchange
              </h2>
              <p>
                Welcome to
                {' '}
                {healthXchangeLink}
                , a pioneering healthcare initiative
                proudly promoted by Favyt Technologies. At
                {' '}
                {healthXchangeLink}
                ,
                we believe in transforming the healthcare experience by providing
                a diverse range of comprehensive and compassionate services tailored
                to meet the unique needs of individuals and their families.
              </p>
              <p>
                At
                {' '}
                {healthXchangeLink}
                , our commitment goes beyond just delivering services;
                it's about fostering a community where health is a shared journey.
                Backed by Favyt Technologies, we leverage cutting-edge solutions to
                bring you a seamless and technology-driven healthcare experience.
              </p>
              <p>
                Join us in redefining healthcare — where personalized care meets innovation.
                {healthXchangeLink}
                , a transformation in care, a partnership in well-being.
              </p>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <h3 className="section-subheading homepage-heading">
                Our Mission & Vision
              </h3>
              <h5 className="mission">
                <b> Mission: </b>
              </h5>
              <p>
                {missionStatement}
              </p>
              <h5 className="vision">
                <b> Vision: </b>
              </h5>
              <p>
                {visionStatement}
              </p>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <br />
              <h3 className="section-subheading homepage-heading">
                What Sets Us Apart
              </h3>
              <ul>
                <li className="sub-heading">
                  Holistic Wellness Approach:
                  <ul>
                    <li className="nested-li">{wellnessApproach}</li>
                  </ul>
                </li>
                <br />
                <li className="sub-heading">
                  Personalized Care Navigation:
                  <ul>
                    <li className="nested-li">{personalizedCare}</li>
                  </ul>
                </li>
                <br />
                <li className="sub-heading">
                  Cutting-edge Health Technology Integration:
                  <ul>
                    <li className="nested-li">{healthTechnologyIntegration}</li>
                  </ul>
                </li>
                <br />
                <li className="sub-heading">
                  Community Engagement and Support:
                  <ul>
                    <li className="nested-li">{communityEngagement}</li>
                  </ul>
                </li>
                <br />
                <li className="sub-heading">
                  Transparent and Affordable Healthcare:
                  <ul>
                    <li className="nested-li">{transparentAffordableHealthcare}</li>
                  </ul>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      <ul className="exchange-list-conatiner">
        <h1 className="homepage-heading">Our Team</h1>
        <div className="card_container">
          {aboutus.map((aboutus) => (
            <AboutusItem key={aboutus.mobile} aboutus={aboutus} />
          ))}
        </div>
      </ul>
    </div>
  );
};

export default Aboutus;
